import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import SettingsIcon from "./SettingsIcon";

export default function CustomCardFooter({ settings, handleSetting }) {
  const [openSettingsMenu, setOpenSettingsMenu] = useState(false);
  const openSettings = Boolean(openSettingsMenu);

  const handleSettingsMenu = (event) =>
    setOpenSettingsMenu(event.currentTarget);
  const handleSettingsMenuClose = () => setOpenSettingsMenu(false);
  const handlSettingsItemClick = (payload) => {
    handleSetting(payload);
    handleSettingsMenuClose();
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        {/* display settings in the card */}
        <div style={{ width: "fix-content" }}>
          {settings
            .filter(({ parent }) => parent.includes("footer"))
            .map((setting) => (
              <SettingsIcon key={setting.id} setting={setting} handleSettingClick={handlSettingsItemClick} />
            ))}
        </div>
        {settings
          .filter(({ parent }) => parent === "menu").length > 0 ? <div>
          <IconButton
            aria-label="graph properties"
            onClick={handleSettingsMenu}
            size="small"
            style={{ padding: 8, marginLeft: 16 }}
          >
            <SettingsOutlinedIcon fontSize="small" />
          </IconButton>
        </div> : null}
      </div>
      {/* display other settings in menu */}
      {openSettings ? (
        <Menu
          id="menu-graph-settings"
          anchorEl={openSettingsMenu}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          keepMounted
          disableScrollLock={true}
          open={openSettings}
          onClose={handleSettingsMenuClose}
        >
          {settings
            .filter(({ parent }) => parent === "menu")
            .map((setting) => (
              <div key={"setting" + setting.id}>
                <SettingsIcon setting={setting} handleSettingClick={handlSettingsItemClick} />
              </div>
            ))}
        </Menu>
      ) : null}
    </div>
  );
}
